/* Scroll-triggered Off-Road lighting; CTA follows the image fade by 300ms. */
(() => {
  'use strict';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = matchMedia('(min-width: 900px)');
  const scenes = new Map();
  let frame = 0;
  function render() {
    frame = 0;
    // Measurements happen in animation frames, never during script evaluation.
    const viewport = window.innerHeight;
    scenes.forEach((state, scene) => {
      if (!state.visible && !state.force) return;
      state.force = false;
      const rect = scene.getBoundingClientRect();
      // Trigger a time-based fade at the former entry point, 100px earlier on desktop.
      const lightLead = desktop.matches ? 100 : 0;
      const entryTop = (viewport - rect.height) / 2 + lightLead + 78;
      // Switch off with the bottom 35% of the section still visible at the screen's top.
      const pastScene = rect.bottom <= rect.height * .35;
      // On upward exit, keep the lights on until only the top quarter remains visible.
      const beforeScene = rect.top >= viewport - rect.height * .25;
      if (pastScene) {
        state.lightingActive = false;
        state.enterFromBelow = true;
      } else if (beforeScene) {
        state.lightingActive = false;
        state.enterFromBelow = false;
      } else if (!state.lightingActive) {
        // Mirror the entry position when returning from below. Keep the scene dark
        // until as much of it has entered the viewport as on the downward approach.
        state.lightingActive = reduced.matches || (state.enterFromBelow
          ? rect.bottom >= viewport - entryTop
          : rect.top <= entryTop);
      }
      const lightingActive = state.lightingActive;
      const progress = lightingActive ? 1 : 0;
      scene.style.setProperty('--offroad-light', progress.toFixed(3));
      // Reveal after the 150ms image fade; cancel if the visitor leaves early.
      if (!lightingActive) {
        clearTimeout(state.ctaTimer);
        state.ctaTimer = null;
        scene.classList.remove('is-cta-revealed');
        if (state.cta) state.cta.inert = true;
      } else if (reduced.matches) {
        clearTimeout(state.ctaTimer);
        state.ctaTimer = null;
        scene.classList.add('is-cta-revealed');
        if (state.cta) state.cta.inert = false;
      } else if (!scene.classList.contains('is-cta-revealed') && state.ctaTimer === null) {
        state.ctaTimer = setTimeout(() => {
          state.ctaTimer = null;
          if (!state.lightingActive || !scene.isConnected) return;
          scene.classList.add('is-cta-revealed');
          if (state.cta) state.cta.inert = false;
        }, 300);
      }
    });
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(render); }
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const state = scenes.get(entry.target);
      if (state) { state.visible = entry.isIntersecting; state.force = true; }
    });
    schedule();
  }, {rootMargin: '150px 0px'});
  function init(root = document) {
    root.querySelectorAll('[data-scroll-lighting]').forEach(scene => {
      if (scenes.has(scene)) return;
      const cta = scene.querySelector('.offroad-cta');
      const state = {visible: false, force: true, cta, ctaTimer: null, lightingActive: false, enterFromBelow: false};
      scene.classList.add('is-lighting-ready');
      if (cta) cta.inert = true;
      scenes.set(scene, state);
      observer.observe(scene);
    });
    schedule();
  }
  addEventListener('scroll', () => {
    if ([...scenes.values()].some(state => state.visible)) schedule();
  }, {passive: true});
  addEventListener('resize', schedule, {passive: true});
  desktop.addEventListener('change', () => {
    scenes.forEach(state => {state.force = true;});
    schedule();
  });
  reduced.addEventListener('change', () => {
    scenes.forEach(state => {state.force = true;});
    schedule();
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    scenes.forEach((state, scene) => {
      if (event.target.contains(scene)) {clearTimeout(state.ctaTimer); observer.unobserve(scene); scenes.delete(scene);}
    });
  });
  init();
})();
